import { SagaIterator } from "redux-saga";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { selectUserCidpId } from "scenes/selectors";
import factory from "utils/getApiHandlerEffect";
import { afterApplicationsLoad, getApplications, setError } from "./redux";

export function* onLoadApplications(): SagaIterator {
  try {
    const cidpId = yield select(selectUserCidpId);
    const apiHandler: APIHandler = yield call(() => factory());

    const response = yield call(() => apiHandler.getUserApplications(cidpId));

    yield put(afterApplicationsLoad(response));
  } catch (e: any) {
    yield put(setError(true));
  }
}

// watcher function
export default function* dashboardSaga() {
  yield takeLatest(getApplications.type, onLoadApplications);
}
